
import { EpimsBaseEntityDto } from './epim-base.dto';

export class ImpactedAssetDto extends EpimsBaseEntityDto{

ImpactedAssetId:string;
LandName:string;
StateName: string;
LgaName: string;
CommunityName: string;
LandSerialNo: string;
Type: string;
Remarks: string;
// CreatedPersonId: string;
// CreatedDate: Date;
length: number;
}
